import * as React from "react";
const SvgErrorTriangle = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 25, viewBox: "0 0 24 25", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 22H23L12 3L1 22ZM13 19H11V17H13V19ZM13 15H11V11H13V15Z", fill: "#AD180E" }));
export default SvgErrorTriangle;
